import { MeasurementSystemEnum } from "service";
import { create } from "zustand";
import { StorageKeysEnum } from "../constants/storage-keys-enum";

export interface GlobalStore {
  system: MeasurementSystemEnum;
  setSystem: (system: MeasurementSystemEnum) => void;
  initialize: (system: MeasurementSystemEnum) => void;
}

const possible = Object.keys(MeasurementSystemEnum);

const useGlobalStore = create<GlobalStore>((setState) => ({
  system: MeasurementSystemEnum.imperial,
  setSystem: (system) => {
    localStorage.setItem(StorageKeysEnum.system, system);
    setState({ system });
  },
  initialize: (sys) => {
    let system =
      sys ||
      localStorage.getItem(StorageKeysEnum.system) ||
      MeasurementSystemEnum.imperial;
    if (!possible.includes(system)) {
      system = MeasurementSystemEnum.imperial;
    }
    localStorage.setItem(StorageKeysEnum.system, system);
    setState({
      system: system as MeasurementSystemEnum,
    });
  },
}));

export default useGlobalStore;
